import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLink from 'components/shared/ButtonLink.styled';
import { LinkText } from 'components/shared/LinkText';
import { Heading2, Heading3 } from 'components/shared/Typography';
import { LoggedUserContext } from 'context/logged-user/loggeduser.context';
import { useI18n } from 'hooks/useI18n';
import { Trans } from 'next-i18next';
import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import { useContext } from 'react';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import ManfrediteLevel from './ManfrediteLevel';
import { StyledIntro, StyledLevels, StyledPath } from './ManfreditePath.styled';

const ManfreditePath: React.FC = () => {
  const { t } = useI18n('manfredite');
  const { locale } = useRouter();

  const { user } = useContext(LoggedUserContext);

  const levels = [
    {
      title: t('path.manfredite-levels.youngling.title'),
      image: getPublicPath('/images/manfredite/younling-dark.png'),
      howTo: t('path.manfredite-levels.youngling.howTo'),
      perks: [t('path.manfredite-levels.youngling.perks')],
      action: true
    },
    {
      title: t('path.manfredite-levels.padawan.title'),
      image: getPublicPath('/images/manfredite/padawan-dark.png'),
      howTo: t('path.manfredite-levels.padawan.howTo'),
      perks: [
        t('path.manfredite-levels.padawan.perk1'),
        t('path.manfredite-levels.padawan.perk2')
      ]
    },
    {
      title: t('path.manfredite-levels.jedi.title'),
      image: getPublicPath('/images/manfredite/jedi-dark.png'),
      howTo: t('path.manfredite-levels.jedi.howTo'),
      perks: [t('path.manfredite-levels.jedi.perks')]
    }
  ];
  return (
    <StyledPath>
      <StyledIntro>
        <Heading2 editorial>{t('path.title')}</Heading2>
        <p>
          <Trans
            ns={'manfredite'}
            i18nKey={'path.description'}
            components={{
              twitter: <strong />,
              manfredDaily: (
                <LinkText href={getAppUrl(APP_URLS.manfredDaily, locale)} />
              ),
              bonilla: (
                <a
                  href="https://twitter.com/david_bonilla"
                  target={'-blank'}
                ></a>
              ),
              yago: (
                <LinkText
                  href={`${getAppUrl(
                    APP_URLS.blog,
                    locale
                  )}/presentacion-manfred-yago-cousino`}
                />
              ),
              registrarte: (
                <LinkText href={getAppUrl(APP_URLS.talent, locale)} />
              )
            }}
          ></Trans>
        </p>
      </StyledIntro>
      <Heading3 editorial>{t('path.manfredite-levels.title')}</Heading3>
      <StyledLevels>
        {levels.map((l, i) => (
          <ManfrediteLevel key={i} level={l} number={i + 1} />
        ))}
      </StyledLevels>
      <StyledIntro>
        <p>
          <Trans
            ns={'manfredite'}
            i18nKey={'path.footer'}
            components={{
              twitter: (
                <a href="https://twitter.com/getmanfred" target={'-blank'}></a>
              ),
              blog: <LinkText href={getAppUrl(APP_URLS.blog, locale)} />,
              linkedIn: (
                <a
                  href="https://www.linkedin.com/company/manfred"
                  target={'-blank'}
                ></a>
              )
            }}
          ></Trans>
        </p>
        {!user && (
          <Link
            href={`${getAppUrl(APP_URLS.join, locale)}?locale=${locale}`}
            passHref
          >
            <ButtonLink variant="primary" sizes="sm">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span>{t('path.cta')}</span>
            </ButtonLink>
          </Link>
        )}
      </StyledIntro>
    </StyledPath>
  );
};

export default ManfreditePath;
